import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { RoleTarget } from 'src/app/assabil-sales/models/entities/role-target';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { PeriodLovComponent } from 'src/app/assabil-admin/components/control-tables/period-lov/period-lov.component';
import { TargetTypeLovComponent } from '../target-type-lov/target-type-lov.component';
import { TargetProductFamilyLovComponent } from '../target-product-family-lov/target-product-family-lov.component';


@Component({
  selector: 'role-target-list',
  templateUrl: './role-target-list.component.html',
  styleUrls: ['./role-target-list.component.scss']
})
export class RoleTargetListComponent extends BasePage2<RoleTarget> {

  // Filter fields
  // -------------------------------------------------------------------------------------
  locked          : boolean = true;
  unlocked        : boolean = true;
  roleCode        : string;
  periodCode      : string;
  targetTypeCode  : string;
  // -------------------------------------------------------------------------------------
      
  // -------------------------------------------------------------------------------------
  roleTargets: RoleTarget[] = [];
  // -------------------------------------------------------------------------------------
  
  // -------------------------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected salesAdminService : SalesAdminService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "roleTarget";
  }
  // -------------------------------------------------------------------------------------

  

//--------------------------------------------------------------------------------------------------------
getRows(): RoleTarget[] {
      return this.roleTargets;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
new(){
  let entity :  RoleTarget = new RoleTarget();
  entity.inserted = true;
  entity.edit     = true;
  entity.damagedReturnTotal     = 0;
  entity.creationDate           = new Date();
  entity.calculatedTarget       = 0;
  entity.target                 = 0;
  entity.achievement            = 0;
  entity.targetDayAverage       = 0;
  entity.achievementDayAverage  = 0;
  entity.returnTotal            = 0;
  entity.freeTotal              = 0;
  entity.damagedReturnTotal     = 0;
  entity.locked                 = false;
  entity.periodDaysNumber       = 0;
  entity.trend                  = 0;
  
  this.roleTargets.push(entity);
  this.roleTargets = [...this.roleTargets];
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
saveRow(roleTarget : RoleTarget): Promise<RoleTarget> {
  return this.salesAdminService.roleTargetSave(roleTarget);
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
lockToggle(roleTarget : RoleTarget) {
  this.salesAdminService.roleTargetLockToggle(roleTarget.id).then(result => {
    roleTarget.locked = result.locked;
})
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
loadFirstPage(){
  this.serverPageNumber =0;
  this.loadData()
}
loadData() {
  this.salesAdminService.roleTargetsGet(this.roleCode, this.periodCode, this.targetTypeCode, this.locked, this.unlocked, this.serverPageNumber).then(result => {
      this.roleTargets = result.roleTargets;
      if(this.serverPageNumber == 0){
        this.totalRowCount    = result.rowCount;
        this.serverPageCount  = result.serverPageCount;
      }
  })
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
enrichField(field : Field){
  
  if (field.prop == 'role') {
    field.modal   = RoleLovComponent;
    field.subProp = 'name';
    return;
  }
  if (field.prop == 'product') {
    field.modal   = ProductLovComponent;
    field.subProp = 'name';
    return;
  }
  if (field.prop == 'targetType') {
    field.modal   = TargetTypeLovComponent;
    field.subProp = 'name';
    return;
  }
  if (field.prop == 'targetProductFamily') {
    field.modal   = TargetProductFamilyLovComponent;
    field.subProp = 'name';
    return;
  }
  if (field.prop == 'period') {
    field.modal   = PeriodLovComponent;
    field.subProp = 'name';
    return;
  }
  //if (field.prop == 'warehouseTransferReasonType') {
  //    field.lov =   {key : "warehouseTransferReasonTypeCode",  value : "name",  data : this.warehouseTransferReasonTypes } ;
  //    field.key = 'warehouseTransferReasonTypeCode';
  //    return;
  //}
}
//--------------------------------------------------------------------------------------------------------

}
